<template>
  <div
      class="InfoCard"
      :class="computedClass"
  >
    <header @click="click" :class="{'header-chevron': chevron}">
      <h1 class="font-size-middle" v-html="title">{{ title }}</h1>
      <div class="arrow-button" :class="{'button-chevron': chevron}">
        <font-awesome-icon v-if="chevron" icon="chevron-down" class="chevron-down-icon"/>
        <font-awesome-icon v-else icon="arrow-down"/>
      </div>
      <p class="font-size-middle" v-if="!opened && !chevron">Rozwiń</p>
      <p class="font-size-middle" v-if="opened && !chevron">Zwiń</p>
    </header>
    <SlideUpDown :active="opened" class="content font-size-middle">
      <slot></slot>
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'

export default {
  name: 'InfoCard',
  components: {
    SlideUpDown,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      default: false,
    },
    headerColor: {
      type: String,
      default: 'white'
    },
    chevron: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    computedClass () {
      return {
        'opened': this.opened,
      }
    },
  },
  methods: {
    click () {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';


.InfoCard {
  user-select: none;
  font-weight: normal;
  display: list-item;
  list-style: none;

  .content {
    margin-left: -200px;
    margin-right: -200px;
    @media only screen and (max-width: 1200px) {
      margin-left: -100px;
      margin-right: -100px;
    }
    @media only screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
      margin-left: 0;
      margin-right: 0;
    }
    @media only screen and (max-width: $phone-max-width) {
      margin-left: 0;
      margin-right: 0;
    }
  }

  header {
    display: grid;
    grid-template-columns: 15px 1fr 40px 80px;
    cursor: pointer;
    @media only screen and (max-width: 600px) {
      grid-template-columns: 15px 1fr 40px 50px;
    }

    p {
      margin-top: auto;
      margin-bottom: auto;
      color: $primary;
    }

    h1 {
      font-weight: normal;
      margin-top: auto;
      margin-bottom: auto;
      transition: 0.1s ease-out color;
      color: white;

      strong {
        color: $primary;
      }

      &.color-primary {
        color: $primary;
      }

      &.color-white {
        color: $white;
      }
    }

    .arrow-button {
      color: $primary;
      display: flex;
      margin-bottom: auto;
      margin-top: auto;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      transform: scale(1, 1);
      transition: 0.2s ease-out transform;

      img {
        flex: 1 1;
        width: 40px;
      }

      .chevron-down-icon {
        height: 2em;
        width: 1.875em;
      }
    }

    .button-chevron {
      margin-left: auto;
    }
  }

.header-chevron {
  grid-template-columns: 1fr 180px;
  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr 40px;
  }

  &::before {
    content: none;
  }
}

  header::before {
    content: '•';
    margin-top: auto;
    margin-bottom: auto;
  }

  &.opened {
    .arrow-button {
      transform: scale(1, -1);
    }
  }
}
</style>
